
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("33jh4", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $hekY6 = parcelRequire("hekY6");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $1hQ0e = parcelRequire("1hQ0e");


var $lmzCg = parcelRequire("lmzCg");


var $dpsRj = parcelRequire("dpsRj");


var $iDrrr = parcelRequire("iDrrr");


var $dX71b = parcelRequire("dX71b");


var $iCvWJ = parcelRequire("iCvWJ");


var $fPRWc = parcelRequire("fPRWc");


var $2OKnq = parcelRequire("2OKnq");


var $g0IDr = parcelRequire("g0IDr");


var $7DQ7D = parcelRequire("7DQ7D");

const $afd57266bdb0eac4$var$defaultMaxItems = 8;
const $afd57266bdb0eac4$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $afd57266bdb0eac4$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $afd57266bdb0eac4$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children;
const $afd57266bdb0eac4$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $afd57266bdb0eac4$var$noop = (0, $dpsRj.default);
const $afd57266bdb0eac4$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $afd57266bdb0eac4$var$breadcrumbStylesOld = null;
const $afd57266bdb0eac4$var$breadcrumbStylesNew = null;
const $afd57266bdb0eac4$var$navStylesNew = null;
const $afd57266bdb0eac4$var$ellipsisItemWrapperStyles = null; // items will get collapsed into ellipsis dropdown
// therefore they are no longer rendered in the DOM
// they need to be passed in to the dropdown
function $afd57266bdb0eac4$var$getItemProps(child) {
    const { text: text, href: href, onClick: onClick, target: target } = child.props;
    const wrappedOnClick = onClick ? (event)=>{
        // Collapsed dropdown items can be activated via keyboard, but the
        // original BreadcrumbsItem onClick contract is mouse-based.
        if ('button' in event) onClick(event);
    } : undefined;
    return {
        text: text ?? '',
        href: href,
        onClick: wrappedOnClick,
        target: target
    };
}
function $afd57266bdb0eac4$var$cloneBreadcrumbChild(child, index, itemCount, registerItem) {
    const isLast = index === itemCount - 1;
    const isCurrentItem = child.type === (0, $dX71b.default);
    return(// eslint-disable-next-line @repo/internal/react/no-clone-element
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
        key: child.key ?? index,
        _overflowRef: registerItem(index),
        ...isLast && !isCurrentItem ? {
            'aria-current': 'page'
        } : {}
    }));
}
const $afd57266bdb0eac4$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(6);
    if ((0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh")) {
        let t0;
        if ($[0] !== props || $[1] !== ref) {
            t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($afd57266bdb0eac4$var$InnerBreadcrumbsNew, {
                ...props,
                ref: ref
            });
            $[0] = props;
            $[1] = ref;
            $[2] = t0;
        } else t0 = $[2];
        return t0;
    }
    let t0;
    if ($[3] !== props || $[4] !== ref) {
        t0 = /*#__PURE__*/ (0, $8aG6j.jsx)($afd57266bdb0eac4$var$InnerBreadcrumbsOld, {
            ...props,
            ref: ref
        });
        $[3] = props;
        $[4] = ref;
        $[5] = t0;
    } else t0 = $[5];
    return t0;
} : (props, ref)=>{
    if ((0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh')) return /*#__PURE__*/ (0, $8aG6j.jsx)($afd57266bdb0eac4$var$InnerBreadcrumbsNew, {
        ...props,
        ref: ref
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)($afd57266bdb0eac4$var$InnerBreadcrumbsOld, {
        ...props,
        ref: ref
    });
});
const $afd57266bdb0eac4$var$InnerBreadcrumbsOld = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(25);
    const { defaultExpanded: t0, isExpanded: isExpanded, maxItems: t1, itemsBeforeCollapse: t2, itemsAfterCollapse: t3, children: t4, testId: testId, onExpand: t5, analyticsContext: analyticsContext, label: t6, ellipsisLabel: t7, size: t8 } = props;
    const defaultExpanded = t0 === undefined ? false : t0;
    const maxItems = t1 === undefined ? $afd57266bdb0eac4$var$defaultMaxItems : t1;
    const itemsBeforeCollapse = t2 === undefined ? 1 : t2;
    const itemsAfterCollapse = t3 === undefined ? 1 : t3;
    const children = t4 === undefined ? [] : t4;
    const providedExpanse = t5 === undefined ? $afd57266bdb0eac4$var$noop : t5;
    const label = t6 === undefined ? $afd57266bdb0eac4$var$defaultBreadcrumbsLabel : t6;
    const ellipsisLabel = t7 === undefined ? $afd57266bdb0eac4$var$defaultEllipsisLabel : t7;
    const size = t8 === undefined ? "medium" : t8;
    const [expanded, setExpanse] = (0, $cozmU.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $cozmU.useState)(false);
    const wrapperRef = (0, $cozmU.useRef)(null);
    const isControlled = typeof isExpanded !== "undefined";
    const isExpansionHandled = providedExpanse !== $afd57266bdb0eac4$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    let t9;
    if ($[0] !== itemsBeforeCollapse) {
        t9 = ()=>{
            if (wrapperRef.current) {
                const listItems = Array.from(wrapperRef.current.querySelectorAll("li"));
                const interactiveElements = listItems.map($afd57266bdb0eac4$var$_temp);
                const elementToFocus = interactiveElements[itemsBeforeCollapse];
                const firstInteractiveElement = interactiveElements[0];
                if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
                else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
                else wrapperRef.current.focus();
            }
            setExpansionTrigger(false);
        };
        $[0] = itemsBeforeCollapse;
        $[1] = t9;
    } else t9 = $[1];
    const focusFirstRevealedMemoized = t9;
    const t10 = !isClickedBySpace;
    let t11;
    if ($[2] !== shouldExpand || $[3] !== t10) {
        t11 = {
            isExpanded: shouldExpand,
            isDisabled: t10
        };
        $[2] = shouldExpand;
        $[3] = t10;
        $[4] = t11;
    } else t11 = $[4];
    (0, $g0IDr.useOnRevealed)(focusFirstRevealedMemoized, t11);
    let t12;
    if ($[5] !== isControlled || $[6] !== isExpansionHandled || $[7] !== providedExpanse) {
        t12 = (event, analyticsEvent)=>{
            if (!isControlled) setExpanse($afd57266bdb0eac4$var$_temp2);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === (0, $1hQ0e.getDocument)()?.activeElement);
            return providedExpanse(event, analyticsEvent);
        };
        $[5] = isControlled;
        $[6] = isExpansionHandled;
        $[7] = providedExpanse;
        $[8] = t12;
    } else t12 = $[8];
    let t13;
    if ($[9] !== analyticsContext || $[10] !== t12) {
        t13 = {
            fn: t12,
            action: "expanded",
            analyticsData: analyticsContext,
            ...$afd57266bdb0eac4$var$analyticsAttributes
        };
        $[9] = analyticsContext;
        $[10] = t12;
        $[11] = t13;
    } else t13 = $[11];
    const handleExpansion = (0, $7r5Hr.usePlatformLeafEventHandler)(t13);
    const childrenArray = $afd57266bdb0eac4$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(childrenArray, (child, index)=>{
        if (typeof child === "string") return child;
        return childrenArray.length - 1 === index ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
            "aria-current": "page"
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray;
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iCvWJ.default), {
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }, "ellipsis"),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    let t14;
    if ($[12] !== ref) {
        t14 = (0, $lmzCg.default)([
            ref,
            wrapperRef
        ]);
        $[12] = ref;
        $[13] = t14;
    } else t14 = $[13];
    let t15;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _3TGfC9HnLE _1UtDYzKGUX _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg"
        ]);
        $[14] = t15;
    } else t15 = $[14];
    let t16;
    if ($[15] !== breadcrumbsItems || $[16] !== testId) {
        t16 = /*#__PURE__*/ (0, $8aG6j.jsx)("ol", {
            "data-testid": testId,
            className: t15,
            children: breadcrumbsItems
        });
        $[15] = breadcrumbsItems;
        $[16] = testId;
        $[17] = t16;
    } else t16 = $[17];
    let t17;
    if ($[18] !== label || $[19] !== t14 || $[20] !== t16) {
        t17 = /*#__PURE__*/ (0, $8aG6j.jsx)("nav", {
            "aria-label": label,
            ref: t14,
            tabIndex: -1,
            children: t16
        });
        $[18] = label;
        $[19] = t14;
        $[20] = t16;
        $[21] = t17;
    } else t17 = $[21];
    let t18;
    if ($[22] !== size || $[23] !== t17) {
        t18 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fPRWc.BreadcrumbsSizeProvider), {
            value: size,
            children: t17
        });
        $[22] = size;
        $[23] = t17;
        $[24] = t18;
    } else t18 = $[24];
    return t18;
} : (props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, maxItems: maxItems = $afd57266bdb0eac4$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $afd57266bdb0eac4$var$noop, analyticsContext: analyticsContext, label: label = $afd57266bdb0eac4$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $afd57266bdb0eac4$var$defaultEllipsisLabel, size: size = 'medium' } = props;
    const [expanded, setExpanse] = (0, $cozmU.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $cozmU.useState)(false);
    const wrapperRef = (0, $cozmU.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $afd57266bdb0eac4$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealedMemoized = (0, $cozmU.useCallback)(()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($afd57266bdb0eac4$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    }, [
        setExpansionTrigger,
        itemsBeforeCollapse,
        wrapperRef
    ]);
    (0, $g0IDr.useOnRevealed)(focusFirstRevealedMemoized, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded_0)=>!expanded_0);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === (0, $1hQ0e.getDocument)()?.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$afd57266bdb0eac4$var$analyticsAttributes
    });
    const childrenArray = $afd57266bdb0eac4$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.map(childrenArray, (child, index)=>{
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? // eslint-disable-next-line @repo/internal/react/no-clone-element
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray;
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            /*#__PURE__*/ (0, $8aG6j.jsx)((0, $iCvWJ.default), {
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }, "ellipsis"),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fPRWc.BreadcrumbsSizeProvider), {
        value: size,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("nav", {
            "aria-label": label,
            ref: (0, $lmzCg.default)([
                ref,
                wrapperRef
            ]),
            tabIndex: -1,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("ol", {
                "data-testid": testId,
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _3TGfC9HnLE _1UtDYzKGUX _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg"
                ]),
                children: breadcrumbsItems
            })
        })
    });
});
const $afd57266bdb0eac4$var$InnerBreadcrumbsNew = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (props, ref)=>{
    const $ = (0, $bDgLe.c)(17);
    const { children: t0, testId: testId, analyticsContext: analyticsContext, label: t1, ellipsisLabel: t2, size: t3 } = props;
    const children = t0 === undefined ? [] : t0;
    const label = t1 === undefined ? $afd57266bdb0eac4$var$defaultBreadcrumbsLabel : t1;
    const ellipsisLabel = t2 === undefined ? $afd57266bdb0eac4$var$defaultEllipsisLabel : t2;
    const size = t3 === undefined ? "medium" : t3;
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children).filter($afd57266bdb0eac4$var$_temp3);
    const itemCount = childrenArray.length;
    const { collapsedIndices: collapsedIndices, naturalWidthsReady: naturalWidthsReady, registerItem: registerItem, registerContainer: registerContainer } = (0, $7DQ7D.default)(itemCount);
    let t4;
    if ($[2] !== analyticsContext) {
        t4 = {
            fn: $afd57266bdb0eac4$var$noop,
            action: "expanded",
            analyticsData: analyticsContext,
            ...$afd57266bdb0eac4$var$analyticsAttributes
        };
        $[2] = analyticsContext;
        $[3] = t4;
    } else t4 = $[3];
    const handleOverflowExpansion = (0, $7r5Hr.usePlatformLeafEventHandler)(t4);
    const collapsedItems = Array.from(collapsedIndices).sort($afd57266bdb0eac4$var$_temp4).map((i)=>$afd57266bdb0eac4$var$getItemProps(childrenArray[i]));
    const renderedItems = [];
    let ellipsisInserted = false;
    childrenArray.forEach((child_1, index_0)=>{
        const isCollapsed = collapsedIndices.has(index_0);
        if (isCollapsed) {
            if (!ellipsisInserted) {
                ellipsisInserted = true;
                renderedItems.push(/*#__PURE__*/ (0, $8aG6j.jsx)("li", {
                    className: (0, $hekY6.default)([
                        "_3iDTPbQ4SZ _24h04i2Njc _0hPCNLDIqT _0aFT5v1qpb _3YEZNOdnbC _4xdlr0DIqT _43nrzTPgdg _3S3RSqFQfX _3VnCAF2ADO _2jfUf9Jg58 _1Y703adnbC _446KM5DIqT _2GPglyKGUX _0GBAIrfzt3 _0AG2YuDIqT"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2OKnq.default), {
                        collapsedItems: collapsedItems,
                        label: ellipsisLabel,
                        onClick: handleOverflowExpansion,
                        testId: testId && `${testId}--breadcrumb-ellipsis`
                    })
                }, "ellipsis"));
            }
            return;
        }
        renderedItems.push($afd57266bdb0eac4$var$cloneBreadcrumbChild(child_1, index_0, itemCount, registerItem));
    });
    const measureItems = !naturalWidthsReady ? childrenArray.map((child_2, index_1)=>$afd57266bdb0eac4$var$cloneBreadcrumbChild(child_2, index_1, itemCount, registerItem)) : null;
    let t5;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3SamIH5UaJ _2YLqiK5UaJ _4c065U1Y8M _2Y7lL41Y8M _4ouGXIdnbC"
        ]);
        $[4] = t5;
    } else t5 = $[4];
    let t6;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
        t6 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _4ouGXIdnbC _0hPCNLDIqT _3TGfC9LRg7 _0aNu0LYbGa _0rIjykdnbC _43nrzTdnbC _2xTnZxdnbC _0GTcwRdnbC _0xmtkodnbC _46hvQmdnbC _03SyCPdnbC _0LQT5EdnbC"
        ]);
        $[5] = t6;
    } else t6 = $[5];
    const t7 = naturalWidthsReady ? renderedItems : measureItems;
    let t8;
    if ($[6] !== registerContainer || $[7] !== t7 || $[8] !== testId) {
        t8 = /*#__PURE__*/ (0, $8aG6j.jsx)("ol", {
            "data-testid": testId,
            ref: registerContainer,
            className: t6,
            children: t7
        });
        $[6] = registerContainer;
        $[7] = t7;
        $[8] = testId;
        $[9] = t8;
    } else t8 = $[9];
    let t9;
    if ($[10] !== label || $[11] !== ref || $[12] !== t8) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)("nav", {
            "aria-label": label,
            ref: ref,
            tabIndex: -1,
            className: t5,
            children: t8
        });
        $[10] = label;
        $[11] = ref;
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== size || $[15] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fPRWc.BreadcrumbsSizeProvider), {
            value: size,
            children: t9
        });
        $[14] = size;
        $[15] = t9;
        $[16] = t10;
    } else t10 = $[16];
    return t10;
} : (props, ref)=>{
    const { children: children = [], testId: testId, analyticsContext: analyticsContext, label: label = $afd57266bdb0eac4$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $afd57266bdb0eac4$var$defaultEllipsisLabel, size: size = 'medium', createAnalyticsEvent: _createAnalyticsEvent } = props;
    const childrenArray = (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).Children.toArray(children).filter((child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child));
    const itemCount = childrenArray.length;
    const { collapsedIndices: collapsedIndices, naturalWidthsReady: naturalWidthsReady, registerItem: registerItem, registerContainer: registerContainer } = (0, $7DQ7D.default)(itemCount);
    const handleOverflowExpansion = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: $afd57266bdb0eac4$var$noop,
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$afd57266bdb0eac4$var$analyticsAttributes
    });
    const collapsedItems = Array.from(collapsedIndices).sort((a, b)=>a - b).map((i)=>$afd57266bdb0eac4$var$getItemProps(childrenArray[i]));
    const renderedItems = [];
    let ellipsisInserted = false;
    childrenArray.forEach((child_1, index_0)=>{
        const isCollapsed = collapsedIndices.has(index_0);
        if (isCollapsed) {
            if (!ellipsisInserted) {
                ellipsisInserted = true;
                renderedItems.push(/*#__PURE__*/ (0, $8aG6j.jsx)("li", {
                    className: (0, $hekY6.default)([
                        "_3iDTPbQ4SZ _24h04i2Njc _0hPCNLDIqT _0aFT5v1qpb _3YEZNOdnbC _4xdlr0DIqT _43nrzTPgdg _3S3RSqFQfX _3VnCAF2ADO _2jfUf9Jg58 _1Y703adnbC _446KM5DIqT _2GPglyKGUX _0GBAIrfzt3 _0AG2YuDIqT"
                    ]),
                    children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $2OKnq.default), {
                        collapsedItems: collapsedItems,
                        label: ellipsisLabel,
                        onClick: handleOverflowExpansion,
                        testId: testId && `${testId}--breadcrumb-ellipsis`
                    })
                }, "ellipsis"));
            }
            return;
        }
        renderedItems.push($afd57266bdb0eac4$var$cloneBreadcrumbChild(child_1, index_0, itemCount, registerItem));
    });
    const measureItems = !naturalWidthsReady ? childrenArray.map((child_2, index_1)=>$afd57266bdb0eac4$var$cloneBreadcrumbChild(child_2, index_1, itemCount, registerItem)) : null;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $fPRWc.BreadcrumbsSizeProvider), {
        value: size,
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("nav", {
            "aria-label": label,
            ref: ref,
            tabIndex: -1,
            className: (0, $hekY6.default)([
                "_4bt5LAnQyn _2WAcuGnQyn _3SamIH5UaJ _2YLqiK5UaJ _4c065U1Y8M _2Y7lL41Y8M _4ouGXIdnbC"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)("ol", {
                "data-testid": testId,
                ref: registerContainer,
                className: (0, $hekY6.default)([
                    "_3iDTPbQ4SZ _4ouGXIdnbC _0hPCNLDIqT _3TGfC9LRg7 _0aNu0LYbGa _0rIjykdnbC _43nrzTdnbC _2xTnZxdnbC _0GTcwRdnbC _0xmtkodnbC _46hvQmdnbC _03SyCPdnbC _0LQT5EdnbC"
                ]),
                children: naturalWidthsReady ? renderedItems : measureItems
            })
        })
    });
});
const $afd57266bdb0eac4$var$Breadcrumbs = /*#__PURE__*/ (0, $cozmU.memo)(/*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(31);
    let analyticsContext;
    let children;
    let createAnalyticsEvent;
    let defaultExpanded;
    let ellipsisLabel;
    let isExpanded;
    let itemsAfterCollapse;
    let itemsBeforeCollapse;
    let label;
    let maxItems;
    let onExpand;
    let props;
    let size;
    let testId;
    if ($[0] !== t0) {
        ({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, size: size, testId: testId, ...props } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = children;
        $[3] = createAnalyticsEvent;
        $[4] = defaultExpanded;
        $[5] = ellipsisLabel;
        $[6] = isExpanded;
        $[7] = itemsAfterCollapse;
        $[8] = itemsBeforeCollapse;
        $[9] = label;
        $[10] = maxItems;
        $[11] = onExpand;
        $[12] = props;
        $[13] = size;
        $[14] = testId;
    } else {
        analyticsContext = $[1];
        children = $[2];
        createAnalyticsEvent = $[3];
        defaultExpanded = $[4];
        ellipsisLabel = $[5];
        isExpanded = $[6];
        itemsAfterCollapse = $[7];
        itemsBeforeCollapse = $[8];
        label = $[9];
        maxItems = $[10];
        onExpand = $[11];
        props = $[12];
        size = $[13];
        testId = $[14];
    }
    let t1;
    if ($[15] !== analyticsContext || $[16] !== children || $[17] !== createAnalyticsEvent || $[18] !== defaultExpanded || $[19] !== ellipsisLabel || $[20] !== isExpanded || $[21] !== itemsAfterCollapse || $[22] !== itemsBeforeCollapse || $[23] !== label || $[24] !== maxItems || $[25] !== onExpand || $[26] !== props || $[27] !== ref || $[28] !== size || $[29] !== testId) {
        t1 = /*#__PURE__*/ (0, $8aG6j.jsx)($afd57266bdb0eac4$var$InnerBreadcrumbs, {
            ...props,
            analyticsContext: analyticsContext,
            children: children,
            createAnalyticsEvent: createAnalyticsEvent,
            defaultExpanded: defaultExpanded,
            ellipsisLabel: ellipsisLabel,
            isExpanded: isExpanded,
            itemsAfterCollapse: itemsAfterCollapse,
            itemsBeforeCollapse: itemsBeforeCollapse,
            label: label,
            maxItems: maxItems,
            onExpand: onExpand,
            size: size,
            ref: ref,
            testId: testId
        });
        $[15] = analyticsContext;
        $[16] = children;
        $[17] = createAnalyticsEvent;
        $[18] = defaultExpanded;
        $[19] = ellipsisLabel;
        $[20] = isExpanded;
        $[21] = itemsAfterCollapse;
        $[22] = itemsBeforeCollapse;
        $[23] = label;
        $[24] = maxItems;
        $[25] = onExpand;
        $[26] = props;
        $[27] = ref;
        $[28] = size;
        $[29] = testId;
        $[30] = t1;
    } else t1 = $[30];
    return t1;
} : ({ analyticsContext: analyticsContext, children: children, createAnalyticsEvent: createAnalyticsEvent, defaultExpanded: defaultExpanded, ellipsisLabel: ellipsisLabel, isExpanded: isExpanded, itemsAfterCollapse: itemsAfterCollapse, itemsBeforeCollapse: itemsBeforeCollapse, label: label, maxItems: maxItems, onExpand: onExpand, size: size, testId: testId, ...props }, ref)=>/*#__PURE__*/ (0, $8aG6j.jsx)($afd57266bdb0eac4$var$InnerBreadcrumbs, {
        ...props,
        analyticsContext: analyticsContext,
        children: children,
        createAnalyticsEvent: createAnalyticsEvent,
        defaultExpanded: defaultExpanded,
        ellipsisLabel: ellipsisLabel,
        isExpanded: isExpanded,
        itemsAfterCollapse: itemsAfterCollapse,
        itemsBeforeCollapse: itemsBeforeCollapse,
        label: label,
        maxItems: maxItems,
        onExpand: onExpand,
        size: size,
        ref: ref,
        testId: testId
    }))); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $afd57266bdb0eac4$export$2e2bcd8739ae039 = $afd57266bdb0eac4$var$Breadcrumbs;
function $afd57266bdb0eac4$var$_temp(li) {
    return li.querySelector($afd57266bdb0eac4$var$interactiveElementSelector);
}
function $afd57266bdb0eac4$var$_temp2(expanded_0) {
    return !expanded_0;
}
function $afd57266bdb0eac4$var$_temp3(child) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).isValidElement(child);
}
function $afd57266bdb0eac4$var$_temp4(a, b) {
    return a - b;
}
module.exports["default"] = $afd57266bdb0eac4$export$2e2bcd8739ae039;

});

parcelRegister("dX71b", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7r5Hr = parcelRequire("7r5Hr");


var $1sCHt = parcelRequire("1sCHt");


var $w6R6I = parcelRequire("w6R6I");


var $lmzCg = parcelRequire("lmzCg");


var $dpsRj = parcelRequire("dpsRj");


var $kTb7m = parcelRequire("kTb7m");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");


var $lpNn5 = parcelRequire("lpNn5");


var $jiltW = parcelRequire("jiltW");


var $8C5a3 = parcelRequire("8C5a3");

const $f5df9bde6b3e6461$var$analyticsAttributes = {
    componentName: 'breadcrumbsCurrentItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $f5df9bde6b3e6461$var$COPY_RESET_DELAY_MS = 2000;
const $f5df9bde6b3e6461$var$ICON_WIDTH_ESTIMATE = 24;
const $f5df9bde6b3e6461$var$unboundedStyles = {
    container: "_2mHwu81Y8M _0bjKvDKxmn _4c065UFQfX _3iDTPbccYA _0hPCNLDIqT _24h04i2Njc _0jFU0V9DVM _487zM87dHp",
    itemWrapper: "_3iDTPbQ4SZ _24h04i2Njc _1EqgXlN91d _0hPCNLDIqT _4xdlr0DIqT _0aFT5v1qpb _0WKd3G4z3T _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg",
    copyButtonWrapper: "_3iDTPbccYA _1YKVNsdnbC _17c2U47dHp _3Tg68S7dHp",
    iconWrapper: "_1UtDYzWYXf",
    iconWrapperSmall: "_27VeLCey7F _2Qxi4ney7F"
};
const $f5df9bde6b3e6461$var$styles = {
    interactiveContainer: "_2mHwu81Y8M _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _2sNsIgmnOE _3iDTPbccYA _0hPCNLDIqT _24h04i2Njc _1UtDYzy7kJ _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMy7kJ _0CMRbky7kJ",
    interactiveContainerMotion: "_23rrnHWE38 _3xtjKN0Rl6 _00uqCYjOvk _1B4rbIo10F _0DCa9Dy7kJ _3sFUREDdj4 _3WzCGiy7kJ",
    interactiveContainerSmall: "_2sNsIg7NXe",
    interactiveContainerLegacy: "_0jFU0V9DVM",
    interactiveContainerWithTruncation: "_4ouGXIdnbC _3YEZNO7dHp",
    iconWrapper: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbccYA _3YEZNOdnbC _39xV02oWWg _0jFU0VoWWg _0hPCNLDIqT _37wbyuDIqT",
    iconWrapperExternal: "_2xTnZxFQfX",
    iconWrapperExternalSmall: "_2xTnZxPgdg",
    text: "_2sNsIgmnOE _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _39HuIbz8Lp _1ANEUSLRg7",
    textSmall: "_2sNsIg7NXe _4bt5LAnQyn _2WAcuGnQyn _1UtDYzy7kJ _39HuIbz8Lp _1ANEUSLRg7",
    textWithTruncation: "_4ouGXIdnbC _1EqgXlN91d _3YEZNO7dHp"
};
const $f5df9bde6b3e6461$var$BreadcrumbsCurrentItem = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(52);
    const { text: text, href: href, onClick: onClick, target: target, analyticsContext: analyticsContext, elemBefore: elemBefore, iconBefore: iconBefore, truncationWidth: truncationWidth, testId: testId, onCopyLink: onCopyLink, onTooltipShown: onTooltipShown, _overflowRef: _overflowRef } = t0;
    const isSmall = (0, $jiltW.useBreadcrumbsSize)() === "small";
    const t1 = onClick ?? (0, $dpsRj.default);
    let t2;
    if ($[0] !== analyticsContext || $[1] !== t1) {
        t2 = {
            fn: t1,
            action: "clicked",
            analyticsData: analyticsContext,
            ...$f5df9bde6b3e6461$var$analyticsAttributes
        };
        $[0] = analyticsContext;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    const handleClick = (0, $7r5Hr.usePlatformLeafEventHandler)(t2);
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const [copied, setCopied] = (0, $cozmU.useState)(false);
    const [linkElement, setLinkElement] = (0, $cozmU.useState)(null);
    const resetTimerRef = (0, $cozmU.useRef)(null);
    let t3;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = (element)=>{
            setLinkElement(element);
        };
        $[3] = t3;
    } else t3 = $[3];
    const setLinkRef = t3;
    const [, shouldShowTooltip] = (0, $8C5a3.default)(truncationWidth, linkElement, (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") ? 0 : resolvedElemBefore ? $f5df9bde6b3e6461$var$ICON_WIDTH_ESTIMATE : 0);
    let t4;
    if ($[4] !== href || $[5] !== onCopyLink) {
        t4 = ()=>{
            if (!navigator.clipboard) return;
            const url = new URL(href, window.location.href).href;
            navigator.clipboard.writeText(url).then(()=>{
                setCopied(true);
                onCopyLink?.();
                if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
                resetTimerRef.current = setTimeout(()=>{
                    setCopied(false);
                }, $f5df9bde6b3e6461$var$COPY_RESET_DELAY_MS);
            }, (0, $dpsRj.default));
        };
        $[4] = href;
        $[5] = onCopyLink;
        $[6] = t4;
    } else t4 = $[6];
    const handleCopy = t4;
    let t5;
    let t6;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>()=>{
                if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
            };
        t6 = [];
        $[7] = t5;
        $[8] = t6;
    } else {
        t5 = $[7];
        t6 = $[8];
    }
    (0, $cozmU.useEffect)(t5, t6);
    let t7;
    if ($[9] !== isSmall || $[10] !== resolvedElemBefore || $[11] !== testId) {
        t7 = resolvedElemBefore && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": testId && `${testId}--icon-before`,
            className: (0, $hekY6.default)([
                $f5df9bde6b3e6461$var$styles.iconWrapper,
                $f5df9bde6b3e6461$var$unboundedStyles.iconWrapper,
                (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $f5df9bde6b3e6461$var$styles.iconWrapperExternal,
                isSmall && $f5df9bde6b3e6461$var$styles.iconWrapperExternalSmall,
                isSmall && $f5df9bde6b3e6461$var$unboundedStyles.iconWrapperSmall
            ]),
            children: resolvedElemBefore
        });
        $[9] = isSmall;
        $[10] = resolvedElemBefore;
        $[11] = testId;
        $[12] = t7;
    } else t7 = $[12];
    const iconElement = t7;
    const t8 = isSmall && $f5df9bde6b3e6461$var$styles.textSmall;
    const t9 = !isSmall && $f5df9bde6b3e6461$var$styles.text;
    const t10 = truncationWidth && $f5df9bde6b3e6461$var$styles.textWithTruncation;
    let t11;
    if ($[13] !== t10 || $[14] !== t8 || $[15] !== t9) {
        t11 = (0, $hekY6.default)([
            t8,
            t9,
            t10
        ]);
        $[13] = t10;
        $[14] = t8;
        $[15] = t9;
        $[16] = t11;
    } else t11 = $[16];
    let t12;
    if ($[17] !== t11 || $[18] !== text) {
        t12 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            className: t11,
            children: text
        });
        $[17] = t11;
        $[18] = text;
        $[19] = t12;
    } else t12 = $[19];
    const textElement = t12;
    let t13;
    if ($[20] !== handleClick || $[21] !== href || $[22] !== iconElement || $[23] !== isSmall || $[24] !== target || $[25] !== testId || $[26] !== textElement || $[27] !== truncationWidth) {
        t13 = (triggerProps)=>{
            const tooltipRef = triggerProps?.ref;
            const handleTriggerClick = (event)=>{
                triggerProps?.onClick?.(event);
                handleClick(event);
            };
            return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor), {
                href: href,
                target: target,
                rel: target === "_blank" ? "noopener noreferrer" : undefined,
                "aria-current": "page",
                onClick: handleTriggerClick,
                onMouseOver: triggerProps?.onMouseOver,
                onMouseOut: triggerProps?.onMouseOut,
                onMouseMove: triggerProps?.onMouseMove,
                onMouseDown: triggerProps?.onMouseDown,
                onFocus: triggerProps?.onFocus,
                onBlur: triggerProps?.onBlur,
                "aria-describedby": triggerProps?.["aria-describedby"],
                testId: testId,
                ref: tooltipRef ? (0, $lmzCg.default)([
                    setLinkRef,
                    tooltipRef
                ]) : setLinkRef,
                xcss: (0, $w6R6I.cx)($f5df9bde6b3e6461$var$styles.interactiveContainer, !(0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $f5df9bde6b3e6461$var$styles.interactiveContainerLegacy, isSmall && $f5df9bde6b3e6461$var$styles.interactiveContainerSmall, truncationWidth != null && $f5df9bde6b3e6461$var$styles.interactiveContainerWithTruncation, (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && $f5df9bde6b3e6461$var$styles.interactiveContainerMotion),
                style: {
                    maxWidth: truncationWidth
                },
                children: [
                    !(0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && iconElement,
                    textElement
                ]
            });
        };
        $[20] = handleClick;
        $[21] = href;
        $[22] = iconElement;
        $[23] = isSmall;
        $[24] = target;
        $[25] = testId;
        $[26] = textElement;
        $[27] = truncationWidth;
        $[28] = t13;
    } else t13 = $[28];
    const renderLink = t13;
    const t14 = copied ? "Copied!" : "Copy link";
    let t15;
    if ($[29] !== copied || $[30] !== handleCopy || $[31] !== testId) {
        t15 = (tooltipProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                "data-breadcrumbs-copy-link": true,
                "data-copied": copied || undefined,
                className: (0, $hekY6.default)([
                    $f5df9bde6b3e6461$var$unboundedStyles.copyButtonWrapper
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                    ...tooltipProps,
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))),
                    isTooltipDisabled: true,
                    label: copied ? "Link copied" : "Copy link",
                    onClick: handleCopy,
                    spacing: "compact",
                    testId: testId && `${testId}--copy-link`
                })
            });
        $[29] = copied;
        $[30] = handleCopy;
        $[31] = testId;
        $[32] = t15;
    } else t15 = $[32];
    let t16;
    if ($[33] !== t14 || $[34] !== t15) {
        t16 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: t14,
            position: "bottom",
            hasNewContentOnTriggerClick: true,
            children: t15
        });
        $[33] = t14;
        $[34] = t15;
        $[35] = t16;
    } else t16 = $[35];
    const copyButton = t16;
    let t17;
    let t18;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t17 = (0, $hekY6.default)([
            $f5df9bde6b3e6461$var$unboundedStyles.itemWrapper
        ]);
        t18 = (0, $hekY6.default)([
            $f5df9bde6b3e6461$var$unboundedStyles.container
        ]);
        $[36] = t17;
        $[37] = t18;
    } else {
        t17 = $[36];
        t18 = $[37];
    }
    let t19;
    if ($[38] !== iconElement) {
        t19 = (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && iconElement;
        $[38] = iconElement;
        $[39] = t19;
    } else t19 = $[39];
    let t20;
    if ($[40] !== onTooltipShown || $[41] !== renderLink || $[42] !== shouldShowTooltip || $[43] !== text) {
        t20 = shouldShowTooltip ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: renderLink
        }) : renderLink();
        $[40] = onTooltipShown;
        $[41] = renderLink;
        $[42] = shouldShowTooltip;
        $[43] = text;
        $[44] = t20;
    } else t20 = $[44];
    let t21;
    if ($[45] !== copyButton || $[46] !== t19 || $[47] !== t20) {
        t21 = /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
            className: t18,
            children: [
                t19,
                t20,
                copyButton
            ]
        });
        $[45] = copyButton;
        $[46] = t19;
        $[47] = t20;
        $[48] = t21;
    } else t21 = $[48];
    let t22;
    if ($[49] !== _overflowRef || $[50] !== t21) {
        t22 = /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
            ref: _overflowRef,
            "data-breadcrumbs-current-item": true,
            className: t17,
            children: t21
        });
        $[49] = _overflowRef;
        $[50] = t21;
        $[51] = t22;
    } else t22 = $[51];
    return t22;
} : ({ text: text, href: href, onClick: onClick, target: target, analyticsContext: analyticsContext, elemBefore: elemBefore, iconBefore: iconBefore, truncationWidth: truncationWidth, testId: testId, onCopyLink: onCopyLink, onTooltipShown: onTooltipShown, _overflowRef: _overflowRef })=>{
    const isSmall = (0, $jiltW.useBreadcrumbsSize)() === 'small';
    const handleClick = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onClick ?? (0, $dpsRj.default),
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$f5df9bde6b3e6461$var$analyticsAttributes
    });
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const [copied, setCopied] = (0, $cozmU.useState)(false);
    const [linkElement, setLinkElement] = (0, $cozmU.useState)(null);
    const resetTimerRef = (0, $cozmU.useRef)(null);
    const setLinkRef = (0, $cozmU.useCallback)((element)=>{
        setLinkElement(element);
    }, []);
    const [, shouldShowTooltip] = (0, $8C5a3.default)(truncationWidth, linkElement, (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') ? 0 : resolvedElemBefore ? $f5df9bde6b3e6461$var$ICON_WIDTH_ESTIMATE : 0);
    const handleCopy = (0, $cozmU.useCallback)(()=>{
        if (!navigator.clipboard) return;
        const url = new URL(href, window.location.href).href;
        navigator.clipboard.writeText(url).then(()=>{
            setCopied(true);
            onCopyLink?.();
            if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
            resetTimerRef.current = setTimeout(()=>{
                setCopied(false);
            }, $f5df9bde6b3e6461$var$COPY_RESET_DELAY_MS);
        }, (0, $dpsRj.default));
    }, [
        href,
        onCopyLink
    ]);
    (0, $cozmU.useEffect)(()=>()=>{
            if (resetTimerRef.current) clearTimeout(resetTimerRef.current);
        }, []);
    const iconElement = resolvedElemBefore && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId && `${testId}--icon-before`,
        className: (0, $hekY6.default)([
            $f5df9bde6b3e6461$var$styles.iconWrapper,
            $f5df9bde6b3e6461$var$unboundedStyles.iconWrapper,
            (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $f5df9bde6b3e6461$var$styles.iconWrapperExternal,
            isSmall && $f5df9bde6b3e6461$var$styles.iconWrapperExternalSmall,
            isSmall && $f5df9bde6b3e6461$var$unboundedStyles.iconWrapperSmall
        ]),
        children: resolvedElemBefore
    });
    const textElement = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        className: (0, $hekY6.default)([
            isSmall && $f5df9bde6b3e6461$var$styles.textSmall,
            !isSmall && $f5df9bde6b3e6461$var$styles.text,
            truncationWidth && $f5df9bde6b3e6461$var$styles.textWithTruncation
        ]),
        children: text
    });
    const renderLink = (triggerProps)=>{
        const tooltipRef = triggerProps?.ref;
        const handleTriggerClick = (event)=>{
            triggerProps?.onClick?.(event);
            handleClick(event);
        };
        return /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $7vK9E.Anchor), {
            href: href,
            target: target,
            rel: target === '_blank' ? 'noopener noreferrer' : undefined,
            "aria-current": "page",
            onClick: handleTriggerClick,
            onMouseOver: triggerProps?.onMouseOver,
            onMouseOut: triggerProps?.onMouseOut,
            onMouseMove: triggerProps?.onMouseMove,
            onMouseDown: triggerProps?.onMouseDown,
            onFocus: triggerProps?.onFocus,
            onBlur: triggerProps?.onBlur,
            "aria-describedby": triggerProps?.['aria-describedby'],
            testId: testId,
            ref: tooltipRef ? (0, $lmzCg.default)([
                setLinkRef,
                tooltipRef
            ]) : setLinkRef,
            xcss: // @ts-ignore -- Expression produces a union type that is too complex to represent. This matches existing `@atlaskit/primitives` handling for complex `xcss={cx(...)}` composition.
            (0, $w6R6I.cx)($f5df9bde6b3e6461$var$styles.interactiveContainer, !(0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $f5df9bde6b3e6461$var$styles.interactiveContainerLegacy, isSmall && $f5df9bde6b3e6461$var$styles.interactiveContainerSmall, truncationWidth != null && $f5df9bde6b3e6461$var$styles.interactiveContainerWithTruncation, (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $f5df9bde6b3e6461$var$styles.interactiveContainerMotion),
            style: {
                maxWidth: truncationWidth
            },
            children: [
                !(0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && iconElement,
                textElement
            ]
        });
    };
    const copyButton = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
        content: copied ? 'Copied!' : 'Copy link',
        position: "bottom",
        hasNewContentOnTriggerClick: true,
        children: (tooltipProps)=>/*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                "data-breadcrumbs-copy-link": true,
                "data-copied": copied || undefined,
                className: (0, $hekY6.default)([
                    $f5df9bde6b3e6461$var$unboundedStyles.copyButtonWrapper
                ]),
                children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                    ...tooltipProps,
                    appearance: "subtle",
                    icon: (0, (/*@__PURE__*/$parcel$interopDefault($kTb7m))),
                    isTooltipDisabled: true,
                    label: copied ? 'Link copied' : 'Copy link',
                    onClick: handleCopy,
                    spacing: "compact",
                    testId: testId && `${testId}--copy-link`
                })
            })
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
        ref: _overflowRef,
        "data-breadcrumbs-current-item": true,
        className: (0, $hekY6.default)([
            $f5df9bde6b3e6461$var$unboundedStyles.itemWrapper
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsxs)("span", {
            className: (0, $hekY6.default)([
                $f5df9bde6b3e6461$var$unboundedStyles.container
            ]),
            children: [
                (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && iconElement,
                shouldShowTooltip ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
                    content: text,
                    position: "bottom",
                    onShow: onTooltipShown,
                    children: renderLink
                }) : renderLink(),
                copyButton
            ]
        })
    });
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $f5df9bde6b3e6461$export$2e2bcd8739ae039 = $f5df9bde6b3e6461$var$BreadcrumbsCurrentItem;
module.exports["default"] = $f5df9bde6b3e6461$export$2e2bcd8739ae039;

});

parcelRegister("jiltW", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $cozmU = parcelRequire("cozmU");


var $gaEqB = parcelRequire("gaEqB");

const $b33aea80784c088a$export$c60a2bbc99661fa2 = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useBreadcrumbsSize() {
    return (0, $cozmU.useContext)((0, $gaEqB.default));
} : function useBreadcrumbsSize() {
    return (0, $cozmU.useContext)((0, $gaEqB.default));
};
module.exports["useBreadcrumbsSize"] = $b33aea80784c088a$export$c60a2bbc99661fa2;

});

parcelRegister("gaEqB", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

/**
 * Shared breadcrumbs size context for the primitives API and refreshed composed breadcrumbs.
 */ const $3def2b1530e0149b$var$BreadcrumbsSizeContext = /*#__PURE__*/ (0, $cozmU.createContext)('medium');
var $3def2b1530e0149b$export$2e2bcd8739ae039 = $3def2b1530e0149b$var$BreadcrumbsSizeContext;
module.exports["default"] = $3def2b1530e0149b$export$2e2bcd8739ae039;

});

parcelRegister("8C5a3", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");

// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $3ef1c5a5d4771e71$var$useOverflowable = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useOverflowable(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    const $ = (0, $bDgLe.c)(9);
    const shouldCheckWidth = truncationWidth && buttonRefCurrent;
    const [hasOverflow, setOverflow] = (0, $cozmU.useState)(Boolean(shouldCheckWidth));
    const [showTooltip, setShowTooltip] = (0, $cozmU.useState)(false);
    let t0;
    let t1;
    if ($[0] !== buttonRefCurrent || $[1] !== iconWidthAllowance || $[2] !== shouldCheckWidth || $[3] !== truncationWidth) {
        t0 = ()=>{
            if (shouldCheckWidth) {
                const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
                const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
                setOverflow(shouldOverflow);
                setShowTooltip(shouldShowTooltip);
            } else {
                setOverflow(false);
                setShowTooltip(false);
            }
        };
        t1 = [
            truncationWidth,
            buttonRefCurrent,
            iconWidthAllowance,
            shouldCheckWidth
        ];
        $[0] = buttonRefCurrent;
        $[1] = iconWidthAllowance;
        $[2] = shouldCheckWidth;
        $[3] = truncationWidth;
        $[4] = t0;
        $[5] = t1;
    } else {
        t0 = $[4];
        t1 = $[5];
    }
    (0, $cozmU.useEffect)(t0, t1);
    let t2;
    if ($[6] !== hasOverflow || $[7] !== showTooltip) {
        t2 = [
            hasOverflow,
            showTooltip
        ];
        $[6] = hasOverflow;
        $[7] = showTooltip;
        $[8] = t2;
    } else t2 = $[8];
    return t2;
} : function useOverflowable(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    const shouldCheckWidth = truncationWidth && buttonRefCurrent;
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $cozmU.useState)(Boolean(shouldCheckWidth));
    const [showTooltip, setShowTooltip] = (0, $cozmU.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $cozmU.useEffect)(()=>{
        if (shouldCheckWidth) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance,
        shouldCheckWidth
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
};
var $3ef1c5a5d4771e71$export$2e2bcd8739ae039 = $3ef1c5a5d4771e71$var$useOverflowable;
module.exports["default"] = $3ef1c5a5d4771e71$export$2e2bcd8739ae039;

});

parcelRegister("iCvWJ", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $w6R6I = parcelRequire("w6R6I");


var $dpsRj = parcelRequire("dpsRj");


var $iDrrr = parcelRequire("iDrrr");


var $hBYtq = parcelRequire("hBYtq");


var $jiltW = parcelRequire("jiltW");

const $839a3575228e0db7$var$noop = (0, $dpsRj.default);
const $839a3575228e0db7$var$itemWrapperStyles = null;
const $839a3575228e0db7$var$styles = {
    root: "_2sNsIgmnOE _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _30huDKYbGa _2mHwu81Y8M _0bjKvDKxmn _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _0KLXru66of _1UtDYzKGUX _3iDTPbccYA _0hPCNLDIqT _4xdlr0DIqT _43nrzTPgdg _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _10n1R5KGUX _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMKGUX _0CMRbky7kJ",
    rootSmall: "_2sNsIg7NXe",
    interactiveMotion: "_23rrnHo10F _3xtjKN0Rl6 _00uqCYjOvk _1B4rbIo10F _0DCa9DKGUX _3sFUREDdj4 _3WzCGiy7kJ"
};
const $839a3575228e0db7$var$EllipsisItem = /*#__PURE__*/ (0, $cozmU.memo)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0)=>{
    const $ = (0, $bDgLe.c)(8);
    const { label: label, onClick: t1, testId: testId } = t0;
    const onClick = t1 === undefined ? $839a3575228e0db7$var$noop : t1;
    const breadcrumbsSize = (0, $jiltW.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === "small";
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _24h04i2Njc _1EqgXlN91d _0jFU0V49iP _0aFT5v1qpb _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _0n7g92FQfX _3DgaZ22ADO _3hLXwc2ADO _1Xuk08dnbC _2jLjk7KGUX _2IsVYLfzt3 _2YiD5UDIqT"
        ]);
        $[0] = t2;
    } else t2 = $[0];
    const t3 = isSmall && $839a3575228e0db7$var$styles.rootSmall;
    let t4;
    if ($[1] !== t3) {
        t4 = (0, $w6R6I.cx)($839a3575228e0db7$var$styles.root, t3, (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && $839a3575228e0db7$var$styles.interactiveMotion);
        $[1] = t3;
        $[2] = t4;
    } else t4 = $[2];
    let t5;
    if ($[3] !== label || $[4] !== onClick || $[5] !== t4 || $[6] !== testId) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
            className: t2,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
                "aria-label": label,
                onClick: onClick,
                xcss: t4,
                testId: testId,
                children: "\u2026"
            })
        });
        $[3] = label;
        $[4] = onClick;
        $[5] = t4;
        $[6] = testId;
        $[7] = t5;
    } else t5 = $[7];
    return t5;
} : ({ label: label, onClick: onClick = $839a3575228e0db7$var$noop, testId: testId })=>{
    const breadcrumbsSize = (0, $jiltW.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === 'small';
    return /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _24h04i2Njc _1EqgXlN91d _0jFU0V49iP _0aFT5v1qpb _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _0n7g92FQfX _3DgaZ22ADO _3hLXwc2ADO _1Xuk08dnbC _2jLjk7KGUX _2IsVYLfzt3 _2YiD5UDIqT"
        ]),
        children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
            "aria-label": label,
            onClick: onClick,
            xcss: (0, $w6R6I.cx)($839a3575228e0db7$var$styles.root, isSmall && $839a3575228e0db7$var$styles.rootSmall, (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $839a3575228e0db7$var$styles.interactiveMotion),
            testId: testId,
            children: "\u2026"
        })
    });
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $839a3575228e0db7$export$2e2bcd8739ae039 = $839a3575228e0db7$var$EllipsisItem;
module.exports["default"] = $839a3575228e0db7$export$2e2bcd8739ae039;

});

parcelRegister("fPRWc", function(module, exports) {

var $gaEqB = parcelRequire("gaEqB");

const $23e2c6453ef39b0a$export$2295e777093f3940 = (0, $gaEqB.default).Provider;
module.exports["BreadcrumbsSizeProvider"] = $23e2c6453ef39b0a$export$2295e777093f3940;

});

parcelRegister("2OKnq", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");

parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $1sCHt = parcelRequire("1sCHt");


var $3vgx3 = parcelRequire("3vgx3");


var $is1T6 = parcelRequire("is1T6");


var $9erVg = parcelRequire("9erVg");


var $6TaGl = parcelRequire("6TaGl");

const $ec7a344b5ea2223d$var$groupWrapperStyles = null; // eslint-disable-next-line @repo/internal/react/require-jsdoc
const $ec7a344b5ea2223d$var$EllipsisPopup = (0, $gtMdU.isReactCompilerActivePlatform)() ? function EllipsisPopup(t0) {
    const $ = (0, $bDgLe.c)(12);
    const { collapsedItems: collapsedItems, label: label, onClick: onClick, testId: testId } = t0;
    let t1;
    if ($[0] !== label || $[1] !== onClick || $[2] !== testId) {
        t1 = (t2)=>{
            const { triggerRef: triggerRef, isSelected: isSelected, testId: _triggerTestId, ...triggerProps } = t2;
            const handleClick = (event)=>{
                triggerProps.onClick?.(event);
                onClick?.(event);
            };
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                ...triggerProps,
                ref: triggerRef,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                label: label,
                isSelected: isSelected,
                appearance: "subtle",
                spacing: "compact",
                isTooltipDisabled: true,
                onClick: handleClick,
                testId: testId
            });
        };
        $[0] = label;
        $[1] = onClick;
        $[2] = testId;
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = (0, $hekY6.default)([
            "_1EqgXlOm3a"
        ]);
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== collapsedItems) {
        t3 = collapsedItems.map($ec7a344b5ea2223d$var$_temp);
        $[5] = collapsedItems;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== t3) {
        t4 = /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: t2,
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9erVg.default), {
                children: t3
            })
        });
        $[7] = t3;
        $[8] = t4;
    } else t4 = $[8];
    let t5;
    if ($[9] !== t1 || $[10] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
            trigger: t1,
            placement: "bottom-start",
            children: t4
        });
        $[9] = t1;
        $[10] = t4;
        $[11] = t5;
    } else t5 = $[11];
    return t5;
} : function EllipsisPopup({ collapsedItems: collapsedItems, label: label, onClick: onClick, testId: testId }) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $3vgx3.default), {
        trigger: ({ triggerRef: triggerRef, isSelected: isSelected, testId: _triggerTestId, ...triggerProps })=>{
            const handleClick = (event)=>{
                triggerProps.onClick?.(event);
                onClick?.(event);
            };
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $1sCHt.default), {
                ...triggerProps,
                ref: triggerRef,
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($6TaGl))),
                label: label,
                isSelected: isSelected,
                appearance: "subtle",
                spacing: "compact",
                isTooltipDisabled: true,
                onClick: handleClick,
                testId: testId
            });
        },
        placement: "bottom-start",
        children: /*#__PURE__*/ (0, $8aG6j.jsx)("div", {
            className: (0, $hekY6.default)([
                "_1EqgXlOm3a"
            ]),
            children: /*#__PURE__*/ (0, $8aG6j.jsx)((0, $9erVg.default), {
                children: collapsedItems.map((item, i)=>/*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
                        href: item.href,
                        target: item.target,
                        onClick: item.onClick,
                        children: item.text
                    }, i))
            })
        })
    });
};
var $ec7a344b5ea2223d$export$2e2bcd8739ae039 = $ec7a344b5ea2223d$var$EllipsisPopup;
function $ec7a344b5ea2223d$var$_temp(item, i) {
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $is1T6.default), {
        href: item.href,
        target: item.target,
        onClick: item.onClick,
        children: item.text
    }, i);
}
module.exports["default"] = $ec7a344b5ea2223d$export$2e2bcd8739ae039;

});

parcelRegister("g0IDr", function(module, exports) {

var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $6iJ3v = parcelRequire("6iJ3v");

const $f40788a777bec402$export$e9c4922b2ecf808a = (0, $gtMdU.isReactCompilerActivePlatform)() ? function useOnRevealed(callback, t0) {
    const $ = (0, $bDgLe.c)(6);
    const { isExpanded: isExpanded, isDisabled: isDisabled } = t0;
    const prevExtended = (0, $6iJ3v.default)(isExpanded);
    let t1;
    let t2;
    if ($[0] !== callback || $[1] !== isDisabled || $[2] !== isExpanded || $[3] !== prevExtended) {
        t1 = ()=>{
            const hasBeenRevealed = !prevExtended && isExpanded;
            if (!isDisabled && hasBeenRevealed) callback();
        };
        t2 = [
            isExpanded,
            isDisabled,
            callback,
            prevExtended
        ];
        $[0] = callback;
        $[1] = isDisabled;
        $[2] = isExpanded;
        $[3] = prevExtended;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $cozmU.useEffect)(t1, t2);
} : function useOnRevealed(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $6iJ3v.default)(isExpanded);
    (0, $cozmU.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
};
module.exports["useOnRevealed"] = $f40788a777bec402$export$e9c4922b2ecf808a;

});

parcelRegister("7DQ7D", function(module, exports) {
$parcel$export(module.exports, "default", () => $84c50e72db23da4d$export$2e2bcd8739ae039);

var $cozmU = parcelRequire("cozmU");

// The ellipsis trigger is a compact IconButton (24px) plus the trailing separator (24px).
const $84c50e72db23da4d$var$ELLIPSIS_WIDTH_ESTIMATE = 48;
// Measurements need layout timing in the browser, but should be a no-op for SSR.
const $84c50e72db23da4d$var$useLayoutEffect = typeof window === 'undefined' ? (0, $cozmU.useEffect) : (0, $cozmU.useLayoutEffect);
function $84c50e72db23da4d$var$setsEqual(a, b) {
    if (a.size !== b.size) return false;
    for (const v of a){
        if (!b.has(v)) return false;
    }
    return true;
}
function $84c50e72db23da4d$var$getMiddleOutCollapseOrder(itemCount) {
    const lastIndex = itemCount - 1;
    const middleIndex = Math.floor((itemCount - 1) / 2);
    const collapseOrder = [];
    if (middleIndex > 0 && middleIndex < lastIndex) collapseOrder.push(middleIndex);
    for(let distance = 1; distance < itemCount; distance++){
        const leftIndex = middleIndex - distance;
        const rightIndex = middleIndex + distance;
        if (leftIndex > 0) collapseOrder.push(leftIndex);
        if (rightIndex < lastIndex) collapseOrder.push(rightIndex);
    }
    return collapseOrder;
}
function $84c50e72db23da4d$export$2e2bcd8739ae039(itemCount) {
    const itemRefs = (0, $cozmU.useRef)([]);
    const containerRef = (0, $cozmU.useRef)(null);
    const naturalWidths = (0, $cozmU.useRef)([]);
    const naturalWidthsReady = (0, $cozmU.useRef)(false);
    const [naturalWidthsReadyState, setNaturalWidthsReadyState] = (0, $cozmU.useState)(false);
    const [collapsedIndices, setCollapsedIndices] = (0, $cozmU.useState)(new Set());
    // Intentionally runs after each render until refs have committed and natural widths are measured.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    $84c50e72db23da4d$var$useLayoutEffect(()=>{
        if (naturalWidthsReady.current) return;
        const widths = itemRefs.current.map((el)=>el?.offsetWidth ?? 0);
        if (widths.some((w)=>w > 0)) {
            naturalWidths.current = widths;
            naturalWidthsReady.current = true;
            setNaturalWidthsReadyState(true);
        }
    });
    const recalculate = (0, $cozmU.useCallback)(()=>{
        const container = containerRef.current;
        if (!container || !naturalWidthsReady.current) return;
        const availableWidth = container.offsetWidth;
        const widths = naturalWidths.current;
        if (itemCount <= 2) {
            setCollapsedIndices((prev)=>prev.size === 0 ? prev : new Set());
            return;
        }
        const totalWidth = widths.reduce((sum, w)=>sum + w, 0);
        if (totalWidth <= availableWidth) {
            setCollapsedIndices((prev)=>prev.size === 0 ? prev : new Set());
            return;
        }
        let usedWidth = totalWidth;
        const newCollapsed = new Set();
        for (const index of $84c50e72db23da4d$var$getMiddleOutCollapseOrder(itemCount)){
            if (newCollapsed.size === 0) usedWidth += $84c50e72db23da4d$var$ELLIPSIS_WIDTH_ESTIMATE;
            newCollapsed.add(index);
            usedWidth -= widths[index] ?? 0;
            if (usedWidth <= availableWidth) break;
        }
        // At the smallest sizes, even first + ellipsis + last may not fit.
        // In that case, also collapse the first item so only ellipsis + last is shown.
        // Note: this branch is only reachable when itemCount > 2 (the early return above
        // handles itemCount <= 2), so collapsing index 0 here always leaves at least one
        // visible item (the last) plus the ellipsis trigger.
        if (usedWidth > availableWidth) newCollapsed.add(0);
        setCollapsedIndices((prev)=>$84c50e72db23da4d$var$setsEqual(prev, newCollapsed) ? prev : newCollapsed);
    }, [
        itemCount
    ]);
    const registerItem = (0, $cozmU.useCallback)((index)=>(el)=>{
            itemRefs.current[index] = el;
        }, []);
    const observerRef = (0, $cozmU.useRef)(null);
    const registerContainer = (0, $cozmU.useCallback)((el)=>{
        // Disconnect any existing observer
        observerRef.current?.disconnect();
        containerRef.current = el;
        if (!el) return;
        if (typeof ResizeObserver === 'undefined') return;
        // Set up ResizeObserver immediately when container mounts
        const observer = new ResizeObserver(()=>{
            recalculate();
        });
        observer.observe(el);
        observerRef.current = observer;
    }, [
        recalculate
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (naturalWidthsReadyState) recalculate();
    }, [
        naturalWidthsReadyState,
        recalculate
    ]);
    // Cleanup observer on unmount
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            observerRef.current?.disconnect();
        };
    }, []);
    (0, $cozmU.useEffect)(()=>{
        naturalWidthsReady.current = false;
        naturalWidths.current = [];
        setNaturalWidthsReadyState(false);
        setCollapsedIndices(new Set());
    }, [
        itemCount
    ]);
    return {
        collapsedIndices: collapsedIndices,
        naturalWidthsReady: naturalWidthsReadyState,
        registerItem: registerItem,
        registerContainer: registerContainer
    };
}

});

parcelRegister("6cA3O", function(module, exports) {
/* breadcrumbs-item.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $8aG6j = parcelRequire("8aG6j");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $iDrrr = parcelRequire("iDrrr");


var $lpNn5 = parcelRequire("lpNn5");


var $g4h89 = parcelRequire("g4h89");


var $aKleR = parcelRequire("aKleR");


var $bggFv = parcelRequire("bggFv");


var $jiltW = parcelRequire("jiltW");


var $8C5a3 = parcelRequire("8C5a3");

const $be0fad57d9cedf06$var$itemWrapperStyles = null;
const $be0fad57d9cedf06$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $be0fad57d9cedf06$var$ICON_WIDTH_ESTIMATE = 24;
const $be0fad57d9cedf06$var$staticItemStyles = null;
const $be0fad57d9cedf06$var$staticItemWithTruncationStyles = null;
const $be0fad57d9cedf06$var$staticItemWithoutTruncationStyles = null;
const $be0fad57d9cedf06$var$motionItemStyles = null;
const $be0fad57d9cedf06$var$BreadcrumbsItem = /*#__PURE__*/ (0, $cozmU.memo)(({ analyticsContext: analyticsContext, component: component, // Analytics event creation comes from context via usePlatformLeafEventHandler.
// Strip this prop so it cannot leak onto DOM-backed controls.
createAnalyticsEvent: _createAnalyticsEvent, href: href, elemBefore: elemBefore, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, // This is overridden by the `buttonRef` below
ref: _ref, target: target, testId: testId, text: text, title: title, truncationWidth: truncationWidth, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-current': ariaCurrent, _overflowRef: _overflowRef, ...rest })=>{
    const [stepElement, setStepElement] = (0, $cozmU.useState)(null);
    const setStepRef = (0, $cozmU.useCallback)((element)=>{
        setStepElement(element);
    }, []);
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const breadcrumbsSize = (0, $jiltW.useBreadcrumbsSize)();
    const leadingIconWidth = resolvedElemBefore ? $be0fad57d9cedf06$var$ICON_WIDTH_ESTIMATE + (breadcrumbsSize === 'small' ? 0 : 2) : 0;
    let iconWidthAllowance = 0;
    if (resolvedElemBefore) iconWidthAllowance += $be0fad57d9cedf06$var$ICON_WIDTH_ESTIMATE;
    if (iconAfter) iconWidthAllowance += $be0fad57d9cedf06$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, shouldShowTooltip] = (0, $8C5a3.default)(truncationWidth, stepElement, // The refresh control now includes the leading icon; exclude it from the truncation check.
    (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') ? -leadingIconWidth : iconWidthAllowance);
    if (!component && (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh')) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $g4h89.default), {
        ref: _overflowRef,
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        elemBefore: resolvedElemBefore,
        href: href,
        // `BreadcrumbsItem.iconAfter` in `src/packages/polaris/component-ideas-idea-view/tests/IssueKey.test.tsx`
        // and `src/packages/polaris/component-ideas-idea-view/tests/IssueBreadcrumbs.test.tsx`.
        // Those consumers need to move the copy-link affordance out of `BreadcrumbsItem` first.
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        onTooltipShown: onTooltipShown,
        shouldShowTooltip: shouldShowTooltip,
        stepRef: setStepRef,
        target: target,
        testId: testId,
        text: text,
        title: title,
        truncationWidth: truncationWidth,
        "aria-current": ariaCurrent
    });
    const buttonOverrideStyles = {
        paddingBlock: "var(--ds-space-025, 2px)",
        fontWeight: "var(--ds-font-weight-regular, 400)"
    }; // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$be0fad57d9cedf06$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = !component ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aKleR.default), {
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-current": ariaCurrent,
        elemBefore: resolvedElemBefore,
        href: href,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        onClick: onClick,
        ref: setStepRef,
        target: target,
        testId: testId,
        title: title,
        truncationWidth: truncationWidth,
        ...rest,
        children: text
    }) : /*#__PURE__*/ (0, $8aG6j.jsx)((0, $bggFv.default), {
        analyticsContext: analyticsContext,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        "aria-current": ariaCurrent,
        component: component,
        hasOverflow: hasOverflow,
        href: href,
        iconAfter: iconAfter,
        iconBefore: resolvedElemBefore,
        onClick: onClick,
        ref: setStepRef,
        target: target,
        testId: testId,
        title: title,
        style: truncationWidth ? {
            ...dynamicItemStyles,
            ...buttonOverrideStyles
        } : buttonOverrideStyles,
        ...rest,
        className: (0, $hekY6.default)([
            "_26BoRwPcut",
            truncationWidth ? "_1EqgXlKIuT" : "_4ouGXIAASz _3YEZNO3mKv",
            (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && "_23rrnHo10F _00uqCYjOvk _3xtjKN0Rl6 _1B4rbIo10F _0DCa9DKGUX _3sFUREDdj4 _3WzCGiy7kJ"
        ]),
        children: text
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
        ref: _overflowRef,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _24h04i2Njc _1EqgXlN91d _0jFU0V49iP _0hPCNLDIqT _0aFT5v1qpb _0WKd3G4z3T _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _0n7g92FQfX _3DgaZ22ADO _3hLXwcJg58 _1Xuk08dnbC _2jLjk7KGUX _2IsVYLfzt3 _2YiD5UDIqT"
        ]),
        children: shouldShowTooltip ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: step
        }) : step
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$be0fad57d9cedf06$export$2e2bcd8739ae039 = $be0fad57d9cedf06$var$BreadcrumbsItem;
module.exports["default"] = $be0fad57d9cedf06$export$2e2bcd8739ae039;

});

parcelRegister("g4h89", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lmzCg = parcelRequire("lmzCg");


var $lpNn5 = parcelRequire("lpNn5");


var $aKleR = parcelRequire("aKleR");

const $940cd9b04c8fc3c8$var$itemWrapperStyles = null;
const $940cd9b04c8fc3c8$var$BreadcrumbsItemBase = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(30);
    const { analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, target: target, testId: testId, text: text, title: title, truncationWidth: truncationWidth, shouldShowTooltip: shouldShowTooltip, stepRef: stepRef, xcss: xcss, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-current": ariaCurrent } = t0;
    const resolvedElemBefore = elemBefore ?? iconBefore;
    let t1;
    if ($[0] !== analyticsContext || $[1] !== ariaCurrent || $[2] !== ariaLabel || $[3] !== ariaLabelledBy || $[4] !== href || $[5] !== iconAfter || $[6] !== iconBefore || $[7] !== onClick || $[8] !== resolvedElemBefore || $[9] !== stepRef || $[10] !== target || $[11] !== testId || $[12] !== text || $[13] !== title || $[14] !== truncationWidth) {
        t1 = (triggerProps)=>{
            const { ref: tooltipRef, testId: _testId, ...tooltipTriggerProps } = triggerProps ?? {};
            return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aKleR.default), {
                ref: tooltipRef ? (0, $lmzCg.default)([
                    stepRef,
                    tooltipRef
                ]) : stepRef,
                analyticsContext: analyticsContext,
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledBy,
                "aria-current": ariaCurrent,
                elemBefore: resolvedElemBefore,
                href: href,
                iconAfter: iconAfter,
                iconBefore: iconBefore,
                onClick: onClick,
                target: target,
                testId: testId,
                title: title,
                triggerProps: triggerProps ? tooltipTriggerProps : undefined,
                truncationWidth: truncationWidth,
                children: text
            });
        };
        $[0] = analyticsContext;
        $[1] = ariaCurrent;
        $[2] = ariaLabel;
        $[3] = ariaLabelledBy;
        $[4] = href;
        $[5] = iconAfter;
        $[6] = iconBefore;
        $[7] = onClick;
        $[8] = resolvedElemBefore;
        $[9] = stepRef;
        $[10] = target;
        $[11] = testId;
        $[12] = text;
        $[13] = title;
        $[14] = truncationWidth;
        $[15] = t1;
    } else t1 = $[15];
    const renderStep = t1;
    let t2;
    if ($[16] !== renderStep) {
        t2 = renderStep();
        $[16] = renderStep;
        $[17] = t2;
    } else t2 = $[17];
    const step = t2;
    let t3;
    if ($[18] !== xcss) {
        t3 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _24h04i2Njc _1EqgXlN91d _0hPCNLDIqT _0aFT5v1qpb _4xdlr0DIqT _0WKd3G4z3T _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _3S3RSqFQfX _3VnCAF2ADO _2jfUf9Jg58 _1Y703adnbC _446KM5Qame _2GPglyKGUX _0GBAIrfzt3 _0AG2YuDIqT",
            xcss
        ]);
        $[18] = xcss;
        $[19] = t3;
    } else t3 = $[19];
    let t4;
    if ($[20] !== onTooltipShown || $[21] !== renderStep || $[22] !== shouldShowTooltip || $[23] !== step || $[24] !== text) {
        t4 = shouldShowTooltip ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: renderStep
        }) : step;
        $[20] = onTooltipShown;
        $[21] = renderStep;
        $[22] = shouldShowTooltip;
        $[23] = step;
        $[24] = text;
        $[25] = t4;
    } else t4 = $[25];
    let t5;
    if ($[26] !== ref || $[27] !== t3 || $[28] !== t4) {
        t5 = /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
            ref: ref,
            className: t3,
            children: t4
        });
        $[26] = ref;
        $[27] = t3;
        $[28] = t4;
        $[29] = t5;
    } else t5 = $[29];
    return t5;
} : ({ analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClick, onTooltipShown: onTooltipShown, target: target, testId: testId, text: text, title: title, truncationWidth: truncationWidth, shouldShowTooltip: shouldShowTooltip, stepRef: stepRef, xcss: xcss, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-current': ariaCurrent }, ref)=>{
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const renderStep = (triggerProps)=>{
        const { ref: tooltipRef, testId: _testId, ...tooltipTriggerProps } = triggerProps ?? {};
        return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $aKleR.default), {
            ref: tooltipRef ? (0, $lmzCg.default)([
                stepRef,
                tooltipRef
            ]) : stepRef,
            analyticsContext: analyticsContext,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            "aria-current": ariaCurrent,
            elemBefore: resolvedElemBefore,
            href: href,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            onClick: onClick,
            target: target,
            testId: testId,
            title: title,
            triggerProps: triggerProps ? tooltipTriggerProps : undefined,
            truncationWidth: truncationWidth,
            children: text
        });
    };
    const step = renderStep();
    return /*#__PURE__*/ (0, $8aG6j.jsx)("li", {
        ref: ref,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _24h04i2Njc _1EqgXlN91d _0hPCNLDIqT _0aFT5v1qpb _4xdlr0DIqT _0WKd3G4z3T _0rIjykPgdg _43nrzTPgdg _2xTnZxPgdg _0GTcwRPgdg _0xmtkoPgdg _46hvQmPgdg _03SyCPPgdg _0LQT5EPgdg _3S3RSqFQfX _3VnCAF2ADO _2jfUf9Jg58 _1Y703adnbC _446KM5Qame _2GPglyKGUX _0GBAIrfzt3 _0AG2YuDIqT",
            xcss
        ]),
        children: shouldShowTooltip ? /*#__PURE__*/ (0, $8aG6j.jsx)((0, $lpNn5.default), {
            content: text,
            position: "bottom",
            onShow: onTooltipShown,
            children: renderStep
        }) : step
    });
}); // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $940cd9b04c8fc3c8$export$2e2bcd8739ae039 = $940cd9b04c8fc3c8$var$BreadcrumbsItemBase;
module.exports["default"] = $940cd9b04c8fc3c8$export$2e2bcd8739ae039;

});

parcelRegister("aKleR", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $7r5Hr = parcelRequire("7r5Hr");


var $w6R6I = parcelRequire("w6R6I");


var $dpsRj = parcelRequire("dpsRj");


var $iDrrr = parcelRequire("iDrrr");


var $7vK9E = parcelRequire("7vK9E");

var $hBYtq = parcelRequire("hBYtq");


var $jiltW = parcelRequire("jiltW");

const $145f806ee7333746$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $145f806ee7333746$var$noop = (0, $dpsRj.default);
const $145f806ee7333746$var$styles = {
    root: "_2sNsIgmnOE _30huDKYbGa _2mHwu81Y8M _0bjKvDcjp5 _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _2Y7lL4Pgdg _0KLXru66of _1UtDYzKGUX _3iDTPbccYA _0hPCNLDIqT _32C2rk98eZ _0i9AWAYbGa _0mm6KQ6wH8 _10n1R5KGUX _0DCa9D98eZ _3932vv0Rl6 _02cRtH6wH8 _0clgaMKGUX _0CMRbky7kJ",
    rootSmall: "_2sNsIg7NXe",
    rootRefresh: "_2mHwu8Pgdg _24h04i2Njc _0jFU0V9DVM",
    interactiveMotion: "_23rrnHo10F _3xtjKN0Rl6 _00uqCYjOvk _1B4rbIo10F _0DCa9DKGUX _3sFUREDdj4 _3WzCGiy7kJ",
    withoutTruncation: "_4ouGXIdnbC _3YEZNO7dHp",
    withTruncation: "_4ouGXIdnbC",
    iconWrapper: "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbccYA _3YEZNOdnbC _39xV02oWWg _0jFU0VoWWg _0hPCNLDIqT _37wbyuDIqT",
    iconWrapperSpacing: "_2xTnZxFQfX",
    iconWrapperSmallSpacing: "_2xTnZxPgdg",
    text: "_4bt5LAnQyn _2WAcuGnQyn _39HuIbz8Lp _1ANEUSLRg7",
    textWithIconAfter: "_2xTnZx1Y8M",
    textWithTruncation: "_4ouGXIdnbC _1EqgXlN91d _3YEZNO7dHp"
};
const $145f806ee7333746$var$unboundedStyles = {
    iconWrapperRefresh: "_39xV02NHnM _0jFU0VNHnM",
    iconWrapperSmall: "_27VeLCey7F _2Qxi4ney7F",
    iconWrapperSmallRefresh: "_27VeLC5zaO _2Qxi4n5zaO",
    iconWrapper: "_1UtDYzWYXf"
}; /**
    * __Step__
    *
    * A button that represents a single step in a breadcrumbs component.
    */ 
const $145f806ee7333746$var$Step = /*#__PURE__*/ (0, $cozmU.forwardRef)((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(106);
    let analyticsContext;
    let ariaCurrent;
    let ariaDescribedBy;
    let ariaLabel;
    let ariaLabelledBy;
    let children;
    let elemBefore;
    let href;
    let iconAfter;
    let iconBefore;
    let onBlur;
    let onFocus;
    let onMouseDown;
    let onMouseMove;
    let onMouseOut;
    let onMouseOver;
    let rest;
    let t1;
    let target;
    let testId;
    let title;
    let triggerProps;
    let truncationWidth;
    if ($[0] !== t0) {
        ({ analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: t1, target: target, testId: testId, children: children, title: title, truncationWidth: truncationWidth, triggerProps: triggerProps, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy, "aria-current": ariaCurrent, "aria-describedby": ariaDescribedBy, onBlur: onBlur, onFocus: onFocus, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onMouseOut: onMouseOut, onMouseOver: onMouseOver, ...rest } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = ariaCurrent;
        $[3] = ariaDescribedBy;
        $[4] = ariaLabel;
        $[5] = ariaLabelledBy;
        $[6] = children;
        $[7] = elemBefore;
        $[8] = href;
        $[9] = iconAfter;
        $[10] = iconBefore;
        $[11] = onBlur;
        $[12] = onFocus;
        $[13] = onMouseDown;
        $[14] = onMouseMove;
        $[15] = onMouseOut;
        $[16] = onMouseOver;
        $[17] = rest;
        $[18] = t1;
        $[19] = target;
        $[20] = testId;
        $[21] = title;
        $[22] = triggerProps;
        $[23] = truncationWidth;
    } else {
        analyticsContext = $[1];
        ariaCurrent = $[2];
        ariaDescribedBy = $[3];
        ariaLabel = $[4];
        ariaLabelledBy = $[5];
        children = $[6];
        elemBefore = $[7];
        href = $[8];
        iconAfter = $[9];
        iconBefore = $[10];
        onBlur = $[11];
        onFocus = $[12];
        onMouseDown = $[13];
        onMouseMove = $[14];
        onMouseOut = $[15];
        onMouseOver = $[16];
        rest = $[17];
        t1 = $[18];
        target = $[19];
        testId = $[20];
        title = $[21];
        triggerProps = $[22];
        truncationWidth = $[23];
    }
    const onClickProvided = t1 === undefined ? $145f806ee7333746$var$noop : t1;
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const breadcrumbsSize = (0, $jiltW.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === "small";
    const leadingIconWidth = resolvedElemBefore ? `${"var(--ds-space-300, 24px)"} + ${isSmall ? "var(--ds-space-0, 0px)" : "var(--ds-space-025, 2px)"}` : "0px";
    let t2;
    if ($[24] !== leadingIconWidth || $[25] !== truncationWidth) {
        t2 = (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && truncationWidth != null ? `calc(${truncationWidth}px + ${leadingIconWidth})` : truncationWidth;
        $[24] = leadingIconWidth;
        $[25] = truncationWidth;
        $[26] = t2;
    } else t2 = $[26];
    const maxWidth = t2;
    let t3;
    if ($[27] !== analyticsContext || $[28] !== onClickProvided) {
        t3 = {
            fn: onClickProvided,
            action: "clicked",
            analyticsData: analyticsContext,
            ...$145f806ee7333746$var$analyticsAttributes
        };
        $[27] = analyticsContext;
        $[28] = onClickProvided;
        $[29] = t3;
    } else t3 = $[29];
    const handleClick = (0, $7r5Hr.usePlatformLeafEventHandler)(t3);
    let t4;
    if ($[30] !== handleClick || $[31] !== triggerProps) {
        t4 = (event)=>{
            triggerProps?.onClick?.(event);
            handleClick(event);
        };
        $[30] = handleClick;
        $[31] = triggerProps;
        $[32] = t4;
    } else t4 = $[32];
    const handleTriggerClick = t4;
    const controlRef = (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") ? ref : undefined;
    const textRef = (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") ? undefined : ref;
    let t5;
    if ($[33] !== isSmall || $[34] !== resolvedElemBefore || $[35] !== testId) {
        t5 = resolvedElemBefore && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            "data-testid": testId && `${testId}--icon-before`,
            className: (0, $hekY6.default)([
                $145f806ee7333746$var$styles.iconWrapper,
                (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $145f806ee7333746$var$unboundedStyles.iconWrapperRefresh,
                $145f806ee7333746$var$unboundedStyles.iconWrapper,
                (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $145f806ee7333746$var$styles.iconWrapperSpacing,
                isSmall && $145f806ee7333746$var$styles.iconWrapperSmallSpacing,
                !(0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && isSmall && $145f806ee7333746$var$unboundedStyles.iconWrapperSmall,
                (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && isSmall && $145f806ee7333746$var$unboundedStyles.iconWrapperSmallRefresh
            ]),
            children: resolvedElemBefore
        });
        $[33] = isSmall;
        $[34] = resolvedElemBefore;
        $[35] = testId;
        $[36] = t5;
    } else t5 = $[36];
    const iconElement = t5;
    let t6;
    if ($[37] !== isSmall || $[38] !== resolvedElemBefore) {
        t6 = !(0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && !isSmall && resolvedElemBefore;
        $[37] = isSmall;
        $[38] = resolvedElemBefore;
        $[39] = t6;
    } else t6 = $[39];
    let t7;
    if ($[40] !== iconElement || $[41] !== isSmall) {
        t7 = ((0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") || isSmall) && iconElement;
        $[40] = iconElement;
        $[41] = isSmall;
        $[42] = t7;
    } else t7 = $[42];
    let t8;
    if ($[43] !== iconAfter || $[44] !== truncationWidth) {
        t8 = (0, $hekY6.default)([
            $145f806ee7333746$var$styles.text,
            (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && Boolean(iconAfter) && $145f806ee7333746$var$styles.textWithIconAfter,
            truncationWidth != null && (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $145f806ee7333746$var$styles.textWithTruncation
        ]);
        $[43] = iconAfter;
        $[44] = truncationWidth;
        $[45] = t8;
    } else t8 = $[45];
    let t9;
    if ($[46] !== children || $[47] !== t8 || $[48] !== textRef) {
        t9 = /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
            ref: textRef,
            className: t8,
            children: children
        });
        $[46] = children;
        $[47] = t8;
        $[48] = textRef;
        $[49] = t9;
    } else t9 = $[49];
    let t10;
    if ($[50] !== iconAfter || $[51] !== t6 || $[52] !== t7 || $[53] !== t9) {
        t10 = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
            children: [
                t6,
                t7,
                t9,
                iconAfter
            ]
        });
        $[50] = iconAfter;
        $[51] = t6;
        $[52] = t7;
        $[53] = t9;
        $[54] = t10;
    } else t10 = $[54];
    const content = t10;
    if (href) {
        const t11 = controlRef;
        const t12 = triggerProps?.onMouseOver ?? onMouseOver;
        const t13 = triggerProps?.onMouseOut ?? onMouseOut;
        const t14 = triggerProps?.onMouseMove ?? onMouseMove;
        const t15 = triggerProps?.onMouseDown ?? onMouseDown;
        const t16 = triggerProps?.onFocus ?? onFocus;
        const t17 = triggerProps?.onBlur ?? onBlur;
        const t18 = triggerProps?.["aria-describedby"] ?? ariaDescribedBy;
        const t19 = target === "_blank" ? "noopener noreferrer" : undefined;
        let t20;
        if ($[55] !== isSmall || $[56] !== truncationWidth) {
            t20 = (0, $w6R6I.cx)($145f806ee7333746$var$styles.root, isSmall && $145f806ee7333746$var$styles.rootSmall, (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $145f806ee7333746$var$styles.rootRefresh, truncationWidth != null && (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $145f806ee7333746$var$styles.withTruncation, truncationWidth == null && $145f806ee7333746$var$styles.withoutTruncation, (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && $145f806ee7333746$var$styles.interactiveMotion);
            $[55] = isSmall;
            $[56] = truncationWidth;
            $[57] = t20;
        } else t20 = $[57];
        let t21;
        if ($[58] !== maxWidth) {
            t21 = {
                maxWidth: maxWidth
            };
            $[58] = maxWidth;
            $[59] = t21;
        } else t21 = $[59];
        let t22;
        if ($[60] !== ariaCurrent || $[61] !== ariaLabel || $[62] !== ariaLabelledBy || $[63] !== content || $[64] !== handleTriggerClick || $[65] !== href || $[66] !== rest || $[67] !== t11 || $[68] !== t12 || $[69] !== t13 || $[70] !== t14 || $[71] !== t15 || $[72] !== t16 || $[73] !== t17 || $[74] !== t18 || $[75] !== t19 || $[76] !== t20 || $[77] !== t21 || $[78] !== target || $[79] !== testId || $[80] !== title) {
            t22 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
                ...rest,
                ref: t11,
                "aria-current": ariaCurrent,
                "aria-label": ariaLabel,
                "aria-labelledby": ariaLabelledBy,
                href: href,
                onClick: handleTriggerClick,
                onMouseOver: t12,
                onMouseOut: t13,
                onMouseMove: t14,
                onMouseDown: t15,
                onFocus: t16,
                onBlur: t17,
                "aria-describedby": t18,
                target: target,
                rel: t19,
                testId: testId,
                title: title,
                xcss: t20,
                style: t21,
                children: content
            });
            $[60] = ariaCurrent;
            $[61] = ariaLabel;
            $[62] = ariaLabelledBy;
            $[63] = content;
            $[64] = handleTriggerClick;
            $[65] = href;
            $[66] = rest;
            $[67] = t11;
            $[68] = t12;
            $[69] = t13;
            $[70] = t14;
            $[71] = t15;
            $[72] = t16;
            $[73] = t17;
            $[74] = t18;
            $[75] = t19;
            $[76] = t20;
            $[77] = t21;
            $[78] = target;
            $[79] = testId;
            $[80] = title;
            $[81] = t22;
        } else t22 = $[81];
        return t22;
    }
    const t11 = controlRef;
    const t12 = triggerProps?.onMouseOver ?? onMouseOver;
    const t13 = triggerProps?.onMouseOut ?? onMouseOut;
    const t14 = triggerProps?.onMouseMove ?? onMouseMove;
    const t15 = triggerProps?.onMouseDown ?? onMouseDown;
    const t16 = triggerProps?.onFocus ?? onFocus;
    const t17 = triggerProps?.onBlur ?? onBlur;
    const t18 = triggerProps?.["aria-describedby"] ?? ariaDescribedBy;
    let t19;
    if ($[82] !== isSmall || $[83] !== truncationWidth) {
        t19 = (0, $w6R6I.cx)($145f806ee7333746$var$styles.root, isSmall && $145f806ee7333746$var$styles.rootSmall, (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $145f806ee7333746$var$styles.rootRefresh, truncationWidth != null && (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") && $145f806ee7333746$var$styles.withTruncation, truncationWidth == null && $145f806ee7333746$var$styles.withoutTruncation, (0, $iDrrr.fg)("platform-dst-motion-uplift-list-item") && $145f806ee7333746$var$styles.interactiveMotion);
        $[82] = isSmall;
        $[83] = truncationWidth;
        $[84] = t19;
    } else t19 = $[84];
    let t20;
    if ($[85] !== maxWidth) {
        t20 = {
            maxWidth: maxWidth
        };
        $[85] = maxWidth;
        $[86] = t20;
    } else t20 = $[86];
    let t21;
    if ($[87] !== ariaCurrent || $[88] !== ariaLabel || $[89] !== ariaLabelledBy || $[90] !== content || $[91] !== handleTriggerClick || $[92] !== rest || $[93] !== t11 || $[94] !== t12 || $[95] !== t13 || $[96] !== t14 || $[97] !== t15 || $[98] !== t16 || $[99] !== t17 || $[100] !== t18 || $[101] !== t19 || $[102] !== t20 || $[103] !== testId || $[104] !== title) {
        t21 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
            ...rest,
            ref: t11,
            "aria-current": ariaCurrent,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledBy,
            onClick: handleTriggerClick,
            onMouseOver: t12,
            onMouseOut: t13,
            onMouseMove: t14,
            onMouseDown: t15,
            onFocus: t16,
            onBlur: t17,
            "aria-describedby": t18,
            testId: testId,
            title: title,
            xcss: t19,
            style: t20,
            children: content
        });
        $[87] = ariaCurrent;
        $[88] = ariaLabel;
        $[89] = ariaLabelledBy;
        $[90] = content;
        $[91] = handleTriggerClick;
        $[92] = rest;
        $[93] = t11;
        $[94] = t12;
        $[95] = t13;
        $[96] = t14;
        $[97] = t15;
        $[98] = t16;
        $[99] = t17;
        $[100] = t18;
        $[101] = t19;
        $[102] = t20;
        $[103] = testId;
        $[104] = title;
        $[105] = t21;
    } else t21 = $[105];
    return t21;
} : ({ analyticsContext: analyticsContext, elemBefore: elemBefore, href: href, iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $145f806ee7333746$var$noop, target: target, testId: testId, children: children, title: title, truncationWidth: truncationWidth, triggerProps: triggerProps, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, 'aria-current': ariaCurrent, 'aria-describedby': ariaDescribedBy, onBlur: onBlur, onFocus: onFocus, onMouseDown: onMouseDown, onMouseMove: onMouseMove, onMouseOut: onMouseOut, onMouseOver: onMouseOver, ...rest }, ref)=>{
    const resolvedElemBefore = elemBefore ?? iconBefore;
    const breadcrumbsSize = (0, $jiltW.useBreadcrumbsSize)();
    const isSmall = breadcrumbsSize === 'small'; // Preserve the text/trailing-icon width budget now that the leading icon is inside the control.
    const leadingIconWidth = resolvedElemBefore ? `${"var(--ds-space-300, 24px)"} + ${isSmall ? "var(--ds-space-0, 0px)" : "var(--ds-space-025, 2px)"}` : '0px';
    const maxWidth = (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && truncationWidth != null ? `calc(${truncationWidth}px + ${leadingIconWidth})` : truncationWidth;
    const handleClick = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$145f806ee7333746$var$analyticsAttributes
    });
    const handleTriggerClick = (event)=>{
        triggerProps?.onClick?.(event);
        handleClick(event);
    };
    const controlRef = (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') ? ref : undefined;
    const textRef = (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') ? undefined : ref;
    const iconElement = resolvedElemBefore && /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
        "data-testid": testId && `${testId}--icon-before`,
        className: (0, $hekY6.default)([
            $145f806ee7333746$var$styles.iconWrapper,
            (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $145f806ee7333746$var$unboundedStyles.iconWrapperRefresh,
            $145f806ee7333746$var$unboundedStyles.iconWrapper,
            (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $145f806ee7333746$var$styles.iconWrapperSpacing,
            isSmall && $145f806ee7333746$var$styles.iconWrapperSmallSpacing,
            !(0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && isSmall && $145f806ee7333746$var$unboundedStyles.iconWrapperSmall,
            (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && isSmall && $145f806ee7333746$var$unboundedStyles.iconWrapperSmallRefresh
        ]),
        children: resolvedElemBefore
    });
    const content = /*#__PURE__*/ (0, $8aG6j.jsxs)((0, $cozmU.Fragment), {
        children: [
            !(0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && !isSmall && resolvedElemBefore,
            ((0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') || isSmall) && iconElement,
            /*#__PURE__*/ (0, $8aG6j.jsx)("span", {
                ref: textRef,
                className: (0, $hekY6.default)([
                    $145f806ee7333746$var$styles.text,
                    (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && Boolean(iconAfter) && $145f806ee7333746$var$styles.textWithIconAfter,
                    truncationWidth != null && (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $145f806ee7333746$var$styles.textWithTruncation
                ]),
                children: children
            }),
            iconAfter
        ]
    });
    if (href) return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7vK9E.Anchor), {
        ...rest,
        ref: controlRef,
        "aria-current": ariaCurrent,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        href: href,
        onClick: handleTriggerClick,
        onMouseOver: triggerProps?.onMouseOver ?? onMouseOver,
        onMouseOut: triggerProps?.onMouseOut ?? onMouseOut,
        onMouseMove: triggerProps?.onMouseMove ?? onMouseMove,
        onMouseDown: triggerProps?.onMouseDown ?? onMouseDown,
        onFocus: triggerProps?.onFocus ?? onFocus,
        onBlur: triggerProps?.onBlur ?? onBlur,
        "aria-describedby": triggerProps?.['aria-describedby'] ?? ariaDescribedBy,
        target: target,
        rel: target === '_blank' ? 'noopener noreferrer' : undefined,
        testId: testId,
        title: title,
        xcss: (0, $w6R6I.cx)($145f806ee7333746$var$styles.root, isSmall && $145f806ee7333746$var$styles.rootSmall, (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $145f806ee7333746$var$styles.rootRefresh, truncationWidth != null && (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $145f806ee7333746$var$styles.withTruncation, truncationWidth == null && $145f806ee7333746$var$styles.withoutTruncation, (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $145f806ee7333746$var$styles.interactiveMotion),
        style: {
            maxWidth: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Width depends on the consumer truncationWidth and leading icon.
            maxWidth
        },
        children: content
    });
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $hBYtq.Pressable), {
        ...rest,
        ref: controlRef,
        "aria-current": ariaCurrent,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy,
        onClick: handleTriggerClick,
        onMouseOver: triggerProps?.onMouseOver ?? onMouseOver,
        onMouseOut: triggerProps?.onMouseOut ?? onMouseOut,
        onMouseMove: triggerProps?.onMouseMove ?? onMouseMove,
        onMouseDown: triggerProps?.onMouseDown ?? onMouseDown,
        onFocus: triggerProps?.onFocus ?? onFocus,
        onBlur: triggerProps?.onBlur ?? onBlur,
        "aria-describedby": triggerProps?.['aria-describedby'] ?? ariaDescribedBy,
        testId: testId,
        title: title,
        xcss: (0, $w6R6I.cx)($145f806ee7333746$var$styles.root, isSmall && $145f806ee7333746$var$styles.rootSmall, (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $145f806ee7333746$var$styles.rootRefresh, truncationWidth != null && (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') && $145f806ee7333746$var$styles.withTruncation, truncationWidth == null && $145f806ee7333746$var$styles.withoutTruncation, (0, $iDrrr.fg)('platform-dst-motion-uplift-list-item') && $145f806ee7333746$var$styles.interactiveMotion),
        style: {
            maxWidth: // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Width depends on the consumer truncationWidth and leading icon.
            maxWidth
        },
        children: content
    });
});
var $145f806ee7333746$export$2e2bcd8739ae039 = $145f806ee7333746$var$Step;
module.exports["default"] = $145f806ee7333746$export$2e2bcd8739ae039;

});

parcelRegister("bggFv", function(module, exports) {

var $8aG6j = parcelRequire("8aG6j");


var $gtMdU = parcelRequire("gtMdU");


var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $7r5Hr = parcelRequire("7r5Hr");


var $7ZB0A = parcelRequire("7ZB0A");


var $dpsRj = parcelRequire("dpsRj");


var $iDrrr = parcelRequire("iDrrr");

const $2ab552b1d511ed22$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $2ab552b1d511ed22$var$noop = (0, $dpsRj.default);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $2ab552b1d511ed22$var$StepOld = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).forwardRef((0, $gtMdU.isReactCompilerActivePlatform)() ? (t0, ref)=>{
    const $ = (0, $bDgLe.c)(24);
    let analyticsContext;
    let component;
    let iconAfter;
    let iconBefore;
    let props;
    let t1;
    let t2;
    let t3;
    let target;
    let testId;
    if ($[0] !== t0) {
        ({ analyticsContext: analyticsContext, component: component, hasOverflow: t1, href: t2, iconAfter: iconAfter, iconBefore: iconBefore, onClick: t3, target: target, testId: testId, ...props } = t0);
        $[0] = t0;
        $[1] = analyticsContext;
        $[2] = component;
        $[3] = iconAfter;
        $[4] = iconBefore;
        $[5] = props;
        $[6] = t1;
        $[7] = t2;
        $[8] = t3;
        $[9] = target;
        $[10] = testId;
    } else {
        analyticsContext = $[1];
        component = $[2];
        iconAfter = $[3];
        iconBefore = $[4];
        props = $[5];
        t1 = $[6];
        t2 = $[7];
        t3 = $[8];
        target = $[9];
        testId = $[10];
    }
    const hasOverflow = t1 === undefined ? true : t1;
    const href = t2 === undefined ? "#" : t2;
    const onClickProvided = t3 === undefined ? $2ab552b1d511ed22$var$noop : t3;
    let t4;
    if ($[11] !== analyticsContext || $[12] !== onClickProvided) {
        t4 = {
            fn: onClickProvided,
            action: "clicked",
            analyticsData: analyticsContext,
            ...$2ab552b1d511ed22$var$analyticsAttributes
        };
        $[11] = analyticsContext;
        $[12] = onClickProvided;
        $[13] = t4;
    } else t4 = $[13];
    const handleClicked = (0, $7r5Hr.usePlatformLeafEventHandler)(t4);
    const resolvedIconAfter = (0, $iDrrr.fg)("platform_dst_breadcrumbs-refresh") ? undefined : hasOverflow ? undefined : iconAfter;
    const t5 = hasOverflow ? undefined : iconBefore;
    let t6;
    if ($[14] !== component || $[15] !== handleClicked || $[16] !== href || $[17] !== props || $[18] !== ref || $[19] !== resolvedIconAfter || $[20] !== t5 || $[21] !== target || $[22] !== testId) {
        t6 = /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
            ...props,
            appearance: "subtle-link",
            component: component,
            href: href,
            iconAfter: resolvedIconAfter,
            iconBefore: t5,
            onClick: handleClicked,
            ref: ref,
            spacing: "none",
            target: target,
            testId: testId
        });
        $[14] = component;
        $[15] = handleClicked;
        $[16] = href;
        $[17] = props;
        $[18] = ref;
        $[19] = resolvedIconAfter;
        $[20] = t5;
        $[21] = target;
        $[22] = testId;
        $[23] = t6;
    } else t6 = $[23];
    return t6;
} : ({ analyticsContext: analyticsContext, component: component, hasOverflow: hasOverflow = true, href: href = '#', iconAfter: iconAfter, iconBefore: iconBefore, onClick: onClickProvided = $2ab552b1d511ed22$var$noop, target: target, testId: testId, ...props }, ref)=>{
    const handleClicked = (0, $7r5Hr.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$2ab552b1d511ed22$var$analyticsAttributes
    });
    const resolvedIconAfter = (0, $iDrrr.fg)('platform_dst_breadcrumbs-refresh') ? undefined : hasOverflow ? undefined : iconAfter;
    return /*#__PURE__*/ (0, $8aG6j.jsx)((0, $7ZB0A.default), {
        ...props,
        appearance: "subtle-link",
        component: component,
        href: href,
        iconAfter: resolvedIconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        spacing: "none",
        target: target,
        testId: testId
    });
});
var $2ab552b1d511ed22$export$2e2bcd8739ae039 = $2ab552b1d511ed22$var$StepOld;
module.exports["default"] = $2ab552b1d511ed22$export$2e2bcd8739ae039;

});


//# sourceMappingURL=RendererWithComponents.98ceb539.js.map
